import home1 from '../../const/lottie/home1.json';
import home2 from '../../const/lottie/home2.json';
import home3 from '../../const/lottie/home3.json';

export const ONE_LINK_URL = 'https://l.duetapp.net/GBnZ/fastweb';

export const TitleColorMap = {
  0: '#8742ff',
  1: '#ff64cd',
  2: '#2396ff',
};

export const backgroundArr = [
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IkpIU0o1UVBJSkxHUE5GRlZVSkVOQk9ZTUxBUkdPVyIsInciOjM4NDAsImgiOjE1MzIsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMDY1NzQwNDI2MzI5NDkzMTQ4OX0?format=originalOFGHLERTH',
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IkpQN09VSjdaVkhFU0xMRVFQSFRVQkhBU05BQTc1VCIsInciOjM4NDAsImgiOjE1MzIsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjo5OTAyMDg1NjI5NjYwNDY0MTI4fQ?format=originalOFGHLERTH',
  'https://cdn.duetapp.net/v1/images/eyJpZCI6Ik8yTjIzVkFBV0xIRUo1Rk5KVlNFQzdNUjZLS0NPTyIsInciOjM4NDAsImgiOjE1MzIsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMjMwNTE5MTgyMjQzNzIyNjA4MX0?format=originalOFGHLERTH',
];

export const backgroundArrMobile = [
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IldVSUlRN1ZUTUxYTEhaQklKVFlQWU1YTFZQNzdOUSIsInciOjc1MCwiaCI6MTMwNCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjU3MTY5Mjc4NjQ0MjAyNTgxOTR9?format=originalOFGHLERTH',
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IlYyNllCSzJGVEJBWElUUUZaRkE1NTc1Nk5XNk5HUiIsInciOjc1MCwiaCI6MTMwNCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjE1MzA5MDU4MjAwODgwNjE2MzM4fQ?format=originalOFGHLERTH',
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IjdWVjRLRkIyU1RCWkI3UVVERkJBVFNGQTdVQVhTSSIsInciOjc1MCwiaCI6MTMwNCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjEwNTA2MjQ0OTkwODM4MTg4NDM0fQ?format=originalOFGHLERTH',
];

export const titleArr = [home1, home2, home3];
